import { useEffect } from 'react';
import { subscriber } from 'app/scripts/init/subscriber';
import { sendErrorEvent } from '@trello/error-reporting';
import { Tags } from '@trello/realtime-updater';
import type {
  MemberSubscription,
  BoardSubscription,
  OrganizationSubscription,
} from '@trello/realtime-updater';

type ModelType = 'Member' | 'Board' | 'Organization';
type SubscriptionType =
  | MemberSubscription
  | BoardSubscription
  | OrganizationSubscription;

export const isMongoId = (id?: string): boolean => {
  return !!id && /^[0-9a-fA-F]{24}$/.test(id);
};

const getEntry = (modelType: ModelType, idModel: string): SubscriptionType => {
  switch (modelType) {
    case 'Member':
      return {
        idModel,
        modelType,
        tags: [Tags.Messages, Tags.Updates],
      };
    case 'Board':
      return {
        idModel,
        modelType,
        tags: [Tags.ClientActions, Tags.Updates],
      };
    case 'Organization':
      return {
        idModel,
        modelType,
        tags: [Tags.AllActions, Tags.Updates],
      };
    default:
      throw new Error('Invalid modelType');
  }
};

export const useSocketSubscription = (
  modelType: ModelType,
  idModel?: string,
  skip?: boolean,
) => {
  useEffect(() => {
    if (!skip) {
      if (idModel && isMongoId(idModel)) {
        const unsubscribe = subscriber.addSubscription(
          getEntry(modelType, idModel),
        );
        return unsubscribe;
      } else {
        sendErrorEvent(
          new Error(
            `Cannot setup subscription to model '${modelType}' using an empty or invalid id: ${idModel}.`,
          ),
        );
      }
    }

    return () => {};
  }, [modelType, idModel, skip]);
};
